import { defineComponent as X, withAsyncContext as v, ref as T, computed as i, watch as M, openBlock as r, createElementBlock as u, normalizeClass as h, normalizeStyle as F, createElementVNode as C, renderSlot as c, createTextVNode as N, toDisplayString as x, createCommentVNode as P } from "vue";
function z(t, e, o) {
  let l = (s) => t(s, ...e);
  return o === void 0 ? l : Object.assign(l, { lazy: o, lazyArgs: e });
}
function $(t, e, o) {
  let l = t.length - e.length;
  if (l === 0) return t(...e);
  if (l === 1) return z(t, e, o);
  throw Error("Wrong number of arguments");
}
function O(t) {
  if (typeof t != "object" || !t) return !1;
  let e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
function R(...t) {
  return $(b, t);
}
function b(t, e) {
  let o = { ...t, ...e };
  for (let l in e) Object.hasOwn(t, l) && O(t[l]) && O(e[l]) && (o[l] = b(t[l], e[l]));
  return o;
}
const w = /* @__PURE__ */ Object.assign({
  "./default/Cash4Life/config.ts": () => import("./config-BkbmKE0n.js").then((t) => t.default),
  "./default/Cash5/config.ts": () => import("./config-p0IBcUG0.js").then((t) => t.default),
  "./default/LottoAmerica/config.ts": () => import("./config-Dnxbn07G.js").then((t) => t.default),
  "./default/LuckyForLife/config.ts": () => import("./config-D5ON2XKG.js").then((t) => t.default),
  "./default/MegaMillions/config.ts": () => import("./config-CnxAhAnl.js").then((t) => t.default),
  "./default/MillionaireForLife/config.ts": () => import("./config-CC6wQmvO.js").then((t) => t.default),
  "./default/Pick3/config.ts": () => import("./config-CfP9ubUV.js").then((t) => t.default),
  "./default/Pick4/config.ts": () => import("./config-CL5iZaKv.js").then((t) => t.default),
  "./default/Pick6/config.ts": () => import("./config-EiZq-dXZ.js").then((t) => t.default),
  "./default/PowerBall/config.ts": () => import("./config-CRfIDDBU.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/config.ts": () => import("./config-CrGz37vx.js").then((t) => t.default),
  "./default/TristateMegabucks/config.ts": () => import("./config-DRZWy8Nq.js").then((t) => t.default),
  "./default/TristatePick3/config.ts": () => import("./config-BnpuN9x6.js").then((t) => t.default),
  "./us-ah/MegaMillions/config.ts": () => import("./config-BUetrfcK.js").then((t) => t.default),
  "./us-ah/PowerBall/config.ts": () => import("./config-DsnNPWl9.js").then((t) => t.default),
  "./us-ar/ArkansasCash3/config.ts": () => import("./config-9VhgeqH3.js").then((t) => t.default),
  "./us-ar/ArkansasCash4/config.ts": () => import("./config-BagbeUTb.js").then((t) => t.default),
  "./us-ar/ArkansasLotto/config.ts": () => import("./config-ClWJiTWv.js").then((t) => t.default),
  "./us-ar/ArkansasNaturalStateJackpot/config.ts": () => import("./config-CSLobg4O.js").then((t) => t.default),
  "./us-az/ArizonaFantasy5/config.ts": () => import("./config-DW2xAkzZ.js").then((t) => t.default),
  "./us-az/ArizonaPick3/config.ts": () => import("./config-Ba1mAwtM.js").then((t) => t.default),
  "./us-az/ArizonaPick4/config.ts": () => import("./config-BCL0coNd.js").then((t) => t.default),
  "./us-az/ArizonaThePick/config.ts": () => import("./config-CoLjjchJ.js").then((t) => t.default),
  "./us-az/MegaMillions/config.ts": () => import("./config-B_SgdCcb.js").then((t) => t.default),
  "./us-az/PowerBall/config.ts": () => import("./config-cCnlnmC7.js").then((t) => t.default),
  "./us-co/ColoradoCash5/config.ts": () => import("./config-CHEaAGzN.js").then((t) => t.default),
  "./us-co/ColoradoLotto/config.ts": () => import("./config-Cu176KFv.js").then((t) => t.default),
  "./us-co/ColoradoPick3/config.ts": () => import("./config-I2shOnlA.js").then((t) => t.default),
  "./us-co/LuckyForLife/config.ts": () => import("./config-K5eR1xNV.js").then((t) => t.default),
  "./us-co/MegaMillions/config.ts": () => import("./config-RMzasi6r.js").then((t) => t.default),
  "./us-co/MillionaireForLife/config.ts": () => import("./config-C2HubR-B.js").then((t) => t.default),
  "./us-co/PowerBall/config.ts": () => import("./config-BDJAfj3r.js").then((t) => t.default),
  "./us-fl/FloridaLotto/config.ts": () => import("./config-LF4bI-gF.js").then((t) => t.default),
  "./us-fl/FloridaPick2/config.ts": () => import("./config-Bx-9LUkZ.js").then((t) => t.default),
  "./us-fl/FloridaPick3/config.ts": () => import("./config-DSa4eGlh.js").then((t) => t.default),
  "./us-fl/FloridaPick4/config.ts": () => import("./config-11urUvQg.js").then((t) => t.default),
  "./us-fl/FloridaPick5/config.ts": () => import("./config-5ViJHwpl.js").then((t) => t.default),
  "./us-ma/MassachusettsKeno/config.ts": () => import("./config-CpK9ZS2g.js").then((t) => t.default),
  "./us-ma/MassachusettsMassCash/config.ts": () => import("./config-C3a8Ui-1.js").then((t) => t.default),
  "./us-ma/MassachusettsMegabucks/config.ts": () => import("./config-BsOeRzk0.js").then((t) => t.default),
  "./us-ma/MassachusettsTheNumbersGame/config.ts": () => import("./config-IhCGGULV.js").then((t) => t.default),
  "./us-me/TristateGimme5/config.ts": () => import("./config-MSRujMSX.js").then((t) => t.default),
  "./us-me/TristatePick4/config.ts": () => import("./config-BVvUuRaa.js").then((t) => t.default),
  "./us-mn/LottoAmerica/config.ts": () => import("./config-Ah8i9yMc.js").then((t) => t.default),
  "./us-mn/MegaMillions/config.ts": () => import("./config-CZMO2JOZ.js").then((t) => t.default),
  "./us-mn/MinnesotaGopher5/config.ts": () => import("./config-BykkwxV1.js").then((t) => t.default),
  "./us-mn/MinnesotaNorth5/config.ts": () => import("./config-56Coljqa.js").then((t) => t.default),
  "./us-mn/MinnesotaPick3/config.ts": () => import("./config-CF2ohtE-.js").then((t) => t.default),
  "./us-mn/PowerBall/config.ts": () => import("./config-LOdnWAl1.js").then((t) => t.default),
  "./us-ne/NebraskaMyDay/config.ts": () => import("./config-8vP0kNLR.js").then((t) => t.default),
  "./us-ne/NebraskaPick3/config.ts": () => import("./config-B5nmzly4.js").then((t) => t.default),
  "./us-ne/NebraskaPick4/config.ts": () => import("./config-Bv_1N5ML.js").then((t) => t.default),
  "./us-ne/NebraskaPick5/config.ts": () => import("./config-BKDP4vl6.js").then((t) => t.default),
  "./us-nj/Cash5/config.ts": () => import("./config-BdMjJYSl.js").then((t) => t.default),
  "./us-nj/Pick3/config.ts": () => import("./config-BHAo035z.js").then((t) => t.default),
  "./us-nj/Pick4/config.ts": () => import("./config-KW44WFFD.js").then((t) => t.default),
  "./us-nj/Pick6/config.ts": () => import("./config-BKFlhaSd.js").then((t) => t.default),
  "./us-ny/Cash4Life/config.ts": () => import("./config-Btwgjq6p.js").then((t) => t.default),
  "./us-ny/MegaMillions/config.ts": () => import("./config-BoA0xrfX.js").then((t) => t.default),
  "./us-ny/MillionaireForLife/config.ts": () => import("./config-BbLmoZfz.js").then((t) => t.default),
  "./us-ny/NewYorkLotto/config.ts": () => import("./config-fW7BmdR8.js").then((t) => t.default),
  "./us-ny/NewYorkNumbers/config.ts": () => import("./config-CE4iz3zT.js").then((t) => t.default),
  "./us-ny/NewYorkPick10/config.ts": () => import("./config-BK10tJ21.js").then((t) => t.default),
  "./us-ny/NewYorkTake5/config.ts": () => import("./config-CayBAx9i.js").then((t) => t.default),
  "./us-ny/NewYorkWin4/config.ts": () => import("./config-6FMJiqRn.js").then((t) => t.default),
  "./us-ny/PowerBall/config.ts": () => import("./config-kCRYDqYg.js").then((t) => t.default),
  "./us-oh/OhioClassicLotto/config.ts": () => import("./config-uEmxG9zp.js").then((t) => t.default),
  "./us-oh/OhioKeno/config.ts": () => import("./config-B-nxv3bE.js").then((t) => t.default),
  "./us-oh/OhioPick3/config.ts": () => import("./config-1OhRDRvS.js").then((t) => t.default),
  "./us-oh/OhioPick4/config.ts": () => import("./config-C7BymUk3.js").then((t) => t.default),
  "./us-oh/OhioPick5/config.ts": () => import("./config-DI8345nk.js").then((t) => t.default),
  "./us-oh/OhioRollingCash5/config.ts": () => import("./config-0erI-eGR.js").then((t) => t.default),
  "./us-or/OregonKeno/config.ts": () => import("./config-4ofi8ytC.js").then((t) => t.default),
  "./us-or/OregonLuckyLines/config.ts": () => import("./config-O2QHrWAJ.js").then((t) => t.default),
  "./us-or/OregonMegabucks/config.ts": () => import("./config-Bz4XPYfv.js").then((t) => t.default),
  "./us-or/OregonPick4/config.ts": () => import("./config-qZbKQ-0o.js").then((t) => t.default),
  "./us-pr/PowerBall/config.ts": () => import("./config-CLHq7_HM.js").then((t) => t.default),
  "./us-pr/PuertoRicoKino/config.ts": () => import("./config-Lh3f89MW.js").then((t) => t.default),
  "./us-pr/PuertoRicoLotoCash/config.ts": () => import("./config-CvJrXd7r.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega2/config.ts": () => import("./config-DuKqeJvN.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega3/config.ts": () => import("./config-OcpqFmHL.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega4/config.ts": () => import("./config-B8s6Dp2k.js").then((t) => t.default),
  "./us-tx/LottoTexas/config.ts": () => import("./config-CNlybtPE.js").then((t) => t.default),
  "./us-tx/TexasAllOrNothing/config.ts": () => import("./config-DKeigFrZ.js").then((t) => t.default),
  "./us-tx/TexasCashFive/config.ts": () => import("./config-BuQjFEaN.js").then((t) => t.default),
  "./us-tx/TexasDaily4/config.ts": () => import("./config-Bk6kL23O.js").then((t) => t.default),
  "./us-tx/TexasPick3/config.ts": () => import("./config-BTnwdzOI.js").then((t) => t.default),
  "./us-tx/TexasTwoStep/config.ts": () => import("./config-zes88ZSk.js").then((t) => t.default)
}), A = /* @__PURE__ */ Object.assign({
  "./default/LuckyForLife/logo.svg": () => import("./logo-B4_SdLJD.js").then((t) => t.default),
  "./default/MegaMillions/logo.svg": () => import("./logo-D6dtG6j_.js").then((t) => t.default),
  "./default/MillionaireForLife/logo.svg": () => import("./logo-Dub31H_-.js").then((t) => t.default),
  "./default/PowerBall/logo.svg": () => import("./logo-DcTT_qHx.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/logo.svg": () => import("./logo-C_2W4cqH.js").then((t) => t.default),
  "./us-ar/ArkansasCash3/logo.svg": () => import("./logo-Cseg5SK0.js").then((t) => t.default),
  "./us-ar/ArkansasCash4/logo.svg": () => import("./logo-Dyb3kHWS.js").then((t) => t.default),
  "./us-ar/ArkansasLotto/logo.svg": () => import("./logo-q6Hg56dW.js").then((t) => t.default),
  "./us-ar/ArkansasNaturalStateJackpot/logo.svg": () => import("./logo-BHOs1wJz.js").then((t) => t.default),
  "./us-az/ArizonaFantasy5/logo.svg": () => import("./logo-DNAYuLGO.js").then((t) => t.default),
  "./us-az/ArizonaPick3/logo.svg": () => import("./logo-B6VildXU.js").then((t) => t.default),
  "./us-az/ArizonaPick4/logo.svg": () => import("./logo-1Uc7pnMp.js").then((t) => t.default),
  "./us-az/ArizonaThePick/logo.svg": () => import("./logo-ChXMmt4o.js").then((t) => t.default),
  "./us-co/ColoradoCash5/logo.svg": () => import("./logo-LCgFuV4D.js").then((t) => t.default),
  "./us-co/ColoradoLotto/logo.svg": () => import("./logo-BepNdWQW.js").then((t) => t.default),
  "./us-co/ColoradoPick3/logo.svg": () => import("./logo-Ce_LCrPF.js").then((t) => t.default),
  "./us-co/LuckyForLife/logo.svg": () => import("./logo-DH3GUJQl.js").then((t) => t.default),
  "./us-co/MegaMillions/logo.svg": () => import("./logo-D9kGwTzG.js").then((t) => t.default),
  "./us-co/MillionaireForLife/logo.svg": () => import("./logo-COHP3Tdr.js").then((t) => t.default),
  "./us-co/PowerBall/logo.svg": () => import("./logo-RqOuMT2y.js").then((t) => t.default),
  "./us-fl/Cash4Life/logo.svg": () => import("./logo-CGFCffQn.js").then((t) => t.default),
  "./us-fl/FloridaLotto/logo.svg": () => import("./logo-BKY6QIZ8.js").then((t) => t.default),
  "./us-fl/FloridaPick2/logo.svg": () => import("./logo-DdusRdLz.js").then((t) => t.default),
  "./us-fl/FloridaPick3/logo.svg": () => import("./logo-CJ78OrIt.js").then((t) => t.default),
  "./us-fl/FloridaPick4/logo.svg": () => import("./logo-tplFEbf_.js").then((t) => t.default),
  "./us-fl/FloridaPick5/logo.svg": () => import("./logo-CIOvSff8.js").then((t) => t.default),
  "./us-ma/MassachusettsKeno/logo.svg": () => import("./logo-ifDrSqif.js").then((t) => t.default),
  "./us-ma/MassachusettsMassCash/logo.svg": () => import("./logo-BdnQ1DOm.js").then((t) => t.default),
  "./us-ma/MassachusettsMegabucks/logo.svg": () => import("./logo-mG4G9d8k.js").then((t) => t.default),
  "./us-ma/MassachusettsTheNumbersGame/logo.svg": () => import("./logo-CxIVF_bh.js").then((t) => t.default),
  "./us-me/LottoAmerica/logo.svg": () => import("./logo-CPYBZ_3M.js").then((t) => t.default),
  "./us-me/TristateGimme5/logo.svg": () => import("./logo-C2W9zGRa.js").then((t) => t.default),
  "./us-me/TristateMegabucks/logo.svg": () => import("./logo-DaZ1dmR1.js").then((t) => t.default),
  "./us-me/TristatePick3/logo.svg": () => import("./logo-B65QlWkG.js").then((t) => t.default),
  "./us-me/TristatePick4/logo.svg": () => import("./logo-61rJ-AfO.js").then((t) => t.default),
  "./us-mn/LottoAmerica/logo.svg": () => import("./logo-DeP_kZIT.js").then((t) => t.default),
  "./us-mn/MinnesotaGopher5/logo.svg": () => import("./logo-D_AZVJK5.js").then((t) => t.default),
  "./us-mn/MinnesotaNorth5/logo.svg": () => import("./logo-BynnZUfI.js").then((t) => t.default),
  "./us-mn/MinnesotaPick3/logo.svg": () => import("./logo-DBTq79Gq.js").then((t) => t.default),
  "./us-ne/LottoAmerica/logo.svg": () => import("./logo-DMLQDtmX.js").then((t) => t.default),
  "./us-ne/NebraskaMyDay/logo.svg": () => import("./logo-C_HowF1U.js").then((t) => t.default),
  "./us-ne/NebraskaPick3/logo.svg": () => import("./logo-C5aNtBO0.js").then((t) => t.default),
  "./us-ne/NebraskaPick4/logo.svg": () => import("./logo-4wZ3st8W.js").then((t) => t.default),
  "./us-ne/NebraskaPick5/logo.svg": () => import("./logo-B1HHrOGc.js").then((t) => t.default),
  "./us-nj/Cash4Life/logo.svg": () => import("./logo-zxey6Wb4.js").then((t) => t.default),
  "./us-nj/Cash5/logo.svg": () => import("./logo-Cx0iCxDI.js").then((t) => t.default),
  "./us-nj/Pick3/logo.svg": () => import("./logo-DbPsR7Mg.js").then((t) => t.default),
  "./us-nj/Pick4/logo.svg": () => import("./logo-CxvGyajF.js").then((t) => t.default),
  "./us-nj/Pick6/logo.svg": () => import("./logo-B-XSZPFr.js").then((t) => t.default),
  "./us-ny/Cash4Life/logo.svg": () => import("./logo-CNGF7g0h.js").then((t) => t.default),
  "./us-ny/MegaMillions/logo.svg": () => import("./logo-Da29N7ci.js").then((t) => t.default),
  "./us-ny/MillionaireForLife/logo.svg": () => import("./logo-CrPqG_XB.js").then((t) => t.default),
  "./us-ny/NewYorkLotto/logo.svg": () => import("./logo-D7WCgPEy.js").then((t) => t.default),
  "./us-ny/NewYorkNumbers/logo.svg": () => import("./logo-Bp1AQ2R6.js").then((t) => t.default),
  "./us-ny/NewYorkPick10/logo.svg": () => import("./logo-CFXbDmDR.js").then((t) => t.default),
  "./us-ny/NewYorkTake5/logo.svg": () => import("./logo-6owx68FH.js").then((t) => t.default),
  "./us-ny/NewYorkWin4/logo.svg": () => import("./logo-LMtq7mW2.js").then((t) => t.default),
  "./us-ny/PowerBall/logo.svg": () => import("./logo-BJ29iook.js").then((t) => t.default),
  "./us-oh/OhioClassicLotto/logo.svg": () => import("./logo-BU58iwo0.js").then((t) => t.default),
  "./us-oh/OhioKeno/logo.png": () => import("./logo-842Gt7yz.js").then((t) => t.default),
  "./us-oh/OhioPick3/logo.svg": () => import("./logo-BuPlI56z.js").then((t) => t.default),
  "./us-oh/OhioPick4/logo.svg": () => import("./logo-4sicdUDz.js").then((t) => t.default),
  "./us-oh/OhioPick5/logo.svg": () => import("./logo-BG4F7jia.js").then((t) => t.default),
  "./us-oh/OhioRollingCash5/logo.svg": () => import("./logo-CTYZv6dw.js").then((t) => t.default),
  "./us-or/OregonLuckyLines/logo.svg": () => import("./logo-CsLu1T6p.js").then((t) => t.default),
  "./us-or/OregonMegabucks/logo.svg": () => import("./logo-CGfflNh2.js").then((t) => t.default),
  "./us-or/OregonPick4/logo.svg": () => import("./logo-CxiB83ch.js").then((t) => t.default),
  "./us-pr/PowerBall/logo.svg": () => import("./logo-CJ-QQ_gV.js").then((t) => t.default),
  "./us-pr/PuertoRicoKino/logo.svg": () => import("./logo-B2KGrOZd.js").then((t) => t.default),
  "./us-pr/PuertoRicoLotoCash/logo.svg": () => import("./logo-PzDPjRDw.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega2/logo.svg": () => import("./logo-BZ1vr8pa.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega3/logo.svg": () => import("./logo-BmBoJ6mV.js").then((t) => t.default),
  "./us-pr/PuertoRicoPega4/logo.svg": () => import("./logo-DQUdTpsK.js").then((t) => t.default),
  "./us-tx/LottoTexas/logo.svg": () => import("./logo-D-mvkvHx.js").then((t) => t.default),
  "./us-tx/MegaMillions/logo.svg": () => import("./logo-CQJF8zr-.js").then((t) => t.default),
  "./us-tx/Powerball/logo.svg": () => import("./logo-C_4C4mrr.js").then((t) => t.default),
  "./us-tx/TexasAllOrNothing/logo.svg": () => import("./logo-D9M8cuto.js").then((t) => t.default),
  "./us-tx/TexasCashFive/logo.svg": () => import("./logo-BaM7NLO9.js").then((t) => t.default),
  "./us-tx/TexasDaily4/logo.svg": () => import("./logo-CUdrdplR.js").then((t) => t.default),
  "./us-tx/TexasPick3/logo.svg": () => import("./logo-C1XECPZp.js").then((t) => t.default),
  "./us-tx/TexasTwoStep/logo.svg": () => import("./logo-Eq9Id0Cf.js").then((t) => t.default)
}), y = ["svg", "png"], j = (t) => typeof t == "function", m = async (t) => t ? j(t) ? await t() ?? null : t ?? null : null, I = async ({ lotteryId: t, licensedTerritory: e }) => {
  const o = await m(
    w[`./${e.toLowerCase()}/${t}/config.ts`]
  );
  let l = null;
  const s = o ? o.extends : t;
  return s && (l = await m(w[`./default/${s}/config.ts`])), o && l ? R(l, o) : o ?? l ?? null;
}, k = async ({ lotteryId: t, licensedTerritory: e }) => {
  const o = `./${e.toLowerCase()}/${t}/logo`;
  for (const s of y) {
    const a = await m(A[`${o}.${s}`]);
    if (a) return a;
  }
  const l = `./default/${t}/logo`;
  for (const s of y) {
    const a = await m(A[`${l}.${s}`]);
    if (a) return a;
  }
  return null;
}, S = ["alt", "height", "src"], q = /* @__PURE__ */ X({
  __name: "LcLotteryLogo",
  props: {
    licensedTerritory: {},
    lotteryId: {},
    size: { default: "medium" },
    variant: { default: "only-allowed" }
  },
  async setup(t) {
    let e, o;
    const l = (n) => n !== "text" && !(n === "only-allowed" && !s?.logo), s = ([e, o] = v(() => I({ licensedTerritory: t.licensedTerritory, lotteryId: t.lotteryId })), e = await e, o(), e), a = T(l(t.variant) ? ([e, o] = v(() => k({ licensedTerritory: t.licensedTerritory, lotteryId: t.lotteryId })), e = await e, o(), e) : null), f = i(() => [
      "lc-lottery-logo",
      `lc-lottery-logo--size-${t.size}`,
      {
        "lc-lottery-logo--long-name": d.value
      }
    ]), d = i(() => g.value ? g.value.length >= 20 : !1), g = i(() => s?.name), p = i(() => s?.style);
    return M(
      () => t.variant,
      async (n) => {
        if (!l(n)) {
          a.value = null;
          return;
        }
        a.value = await k({ licensedTerritory: t.licensedTerritory, lotteryId: t.lotteryId });
      }
    ), (n, J) => a.value && t.variant !== "text" ? (r(), u("img", {
      key: 0,
      class: h([f.value, "lc-lottery-logo__image"]),
      alt: g.value,
      height: t.size === "large" ? 48 : 36,
      src: a.value
    }, null, 10, S)) : (r(), u("span", {
      key: 1,
      class: h([f.value, "lc-lottery-logo__text"]),
      style: F({
        "--lottery-logo-color": p.value?.highFrequency?.teaser?.logoColor || p.value?.colorPrimary
      })
    }, [
      C("span", null, [
        c(n.$slots, "default", {}, () => [
          N(x(g.value), 1)
        ])
      ])
    ], 6));
  }
}), Q = ["all", "only-allowed", "text"], U = ["fluid", "large", "medium", "small"], B = /* @__PURE__ */ Object.assign({
  "./default/PowerBallXsAndOs/helmets/ari.svg": () => import("./ari-pfV7emTq.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/atl.svg": () => import("./atl-DQOUbFAM.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/bal.svg": () => import("./bal-DTqLXZPR.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/buf.svg": () => import("./buf-BRyGzECU.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/car.svg": () => import("./car-a9N-27Qg.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/chi.svg": () => import("./chi-D7Cx-42U.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/cin.svg": () => import("./cin-DlcsSvLj.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/cle.svg": () => import("./cle-czDtqquj.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/dal.svg": () => import("./dal-DRfCEwKA.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/den.svg": () => import("./den-CAixW3R-.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/det.svg": () => import("./det-CGUd7Cac.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/gb.svg": () => import("./gb-B6C5HO-4.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/hou.svg": () => import("./hou-DmgkShA5.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/ind.svg": () => import("./ind-CbyiT5V7.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/jax.svg": () => import("./jax-58iVJgeI.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/kc.svg": () => import("./kc-BFW3_bJy.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/lac.svg": () => import("./lac-BUX3n8UX.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/lar.svg": () => import("./lar-D4xEq4ln.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/lv.svg": () => import("./lv-JWd_sKdH.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/mia.svg": () => import("./mia-D36TKVik.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/min.svg": () => import("./min-D4e7lUFK.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/ne.svg": () => import("./ne-gpzispAS.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/no.svg": () => import("./no-D7qijh6k.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/nyg.svg": () => import("./nyg-Zrx5xqry.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/nyj.svg": () => import("./nyj-opi5r78i.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/phi.svg": () => import("./phi-BoNKsM_I.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/pit.svg": () => import("./pit-Cn8um1GN.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/sea.svg": () => import("./sea-CSU5lw12.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/sf.svg": () => import("./sf-VDxIB2t3.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/tb.svg": () => import("./tb-C915ljjh.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/ten.svg": () => import("./ten-BISI_km8.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/helmets/was.svg": () => import("./was-DyxQTQO6.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ari.svg": () => import("./ari-Bh1KN1uD.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/atl.svg": () => import("./atl-D6LJpuik.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/bal.svg": () => import("./bal-DflXhvDD.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/buf.svg": () => import("./buf-BI5JRH7L.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/car.svg": () => import("./car-BVqNiDyq.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/chi.svg": () => import("./chi-DQdgEjd-.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/cin.svg": () => import("./cin-CN83cDBM.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/cle.svg": () => import("./cle-DQ4xZHs5.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/dal.svg": () => import("./dal-DMaoOhrk.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/den.svg": () => import("./den-D6946XvL.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/det.svg": () => import("./det-BIqCLDNz.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/gb.svg": () => import("./gb-I_eYTbjA.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/hou.svg": () => import("./hou-D1-VR8qn.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ind.svg": () => import("./ind-DV9ltQqq.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/jax.svg": () => import("./jax-bkDFys5L.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/kc.svg": () => import("./kc-D9K5iXPa.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lac.svg": () => import("./lac-nh_92v6B.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lar.svg": () => import("./lar-Cq6zR7vu.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/lv.svg": () => import("./lv-MKtep5Cc.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/mia.svg": () => import("./mia-4bL_-pmk.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/min.svg": () => import("./min-CzaNwXI6.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ne.svg": () => import("./ne-BWagxEvO.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/no.svg": () => import("./no-Yf-XD2Rv.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/nyg.svg": () => import("./nyg-C7sDnFfs.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/nyj.svg": () => import("./nyj-C1lTc4t2.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/phi.svg": () => import("./phi-GKBEA_gy.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/pit.svg": () => import("./pit-t7N007tv.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/sea.svg": () => import("./sea-DnL0LWcY.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/sf.svg": () => import("./sf-BfQdhBvE.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/tb.svg": () => import("./tb-BKN12aCX.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/ten.svg": () => import("./ten-CZll_Mkg.js").then((t) => t.default),
  "./default/PowerBallXsAndOs/team-logos/was.svg": () => import("./was-WSQ3FvuJ.js").then((t) => t.default)
}), G = {
  helmet: "helmets",
  team: "team-logos"
}, E = (t) => typeof t == "function", L = async (t) => t ? E(t) ? await t() ?? null : t ?? null : null, Y = async ({
  licensedTerritory: t,
  lotteryId: e,
  team: o,
  variant: l = "team"
}) => {
  const s = G[l], a = `${o.toLowerCase()}.svg`, f = `./${t.toLowerCase()}/${e}/${s}/${a}`, d = await L(B[f]);
  return d || L(B[`./default/${e}/${s}/${a}`]);
}, V = {
  key: 0,
  class: "lc-lottery-team-tile__icon-wrap"
}, K = ["alt", "src"], D = { class: "lc-lottery-team-tile__label" }, tt = /* @__PURE__ */ X({
  __name: "LcLotteryTeamTile",
  props: {
    licensedTerritory: {},
    lotteryId: {},
    disabled: { type: Boolean, default: !1 },
    team: {},
    logoVariant: { default: "team" },
    size: { default: "large" },
    selected: { type: Boolean, default: !1 },
    matching: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = T(null), o = i(() => [
      `lc-lottery-team-tile--size-${t.size}`,
      {
        "lc-lottery-team-tile--disabled": t.disabled,
        "lc-lottery-team-tile--selected": t.selected
      }
    ]);
    return M(
      () => [t.licensedTerritory, t.lotteryId, t.team, t.logoVariant],
      async () => {
        e.value = await Y({
          licensedTerritory: t.licensedTerritory,
          lotteryId: t.lotteryId,
          team: t.team,
          variant: t.logoVariant
        });
      },
      { immediate: !0 }
    ), (l, s) => (r(), u("div", {
      class: h(["lc-lottery-team-tile", o.value])
    }, [
      t.matching ? (r(), u("div", V, [
        c(l.$slots, "matching-icon")
      ])) : P("", !0),
      e.value ? (r(), u("img", {
        key: 1,
        class: "lc-lottery-team-tile__logo",
        alt: t.team,
        draggable: "false",
        src: e.value
      }, null, 8, K)) : P("", !0),
      C("span", D, [
        c(l.$slots, "default", {}, () => [
          N(x(t.team), 1)
        ])
      ])
    ], 2));
  }
}), _ = 65, H = 5, W = 31, et = (t) => {
  const e = [];
  for (let o = t; o > 0; o >>= H)
    e.push(String.fromCharCode(_ + ((o & W) - 1)));
  return e.reverse().join("");
}, ot = ["team", "helmet"], lt = ["large", "medium-large", "medium", "small"];
export {
  U as LC_LOTTERY_LOGO_SIZES,
  Q as LC_LOTTERY_LOGO_VARIANTS,
  q as LcLotteryLogo,
  tt as LcLotteryTeamTile,
  ot as TEAM_LOGO_VARIANTS,
  lt as TEAM_TILE_SIZES,
  et as decodeXsAndOsTeamName,
  Y as getTeamLogo
};
